import { Container } from 'reactstrap';
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS } from 'chart.js/auto'

export default function Graph (props) {
    
    const data = {
        labels: Object.keys(props.data),
        datasets: [
            {
            data: Object.values(props.data),
            backgroundColor: [
                '#212a5c'
              ]
            },
        ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          grid: {
            display: false
          }
        },
        y: {
          grid: {
            display: false
          }
        }
      },
      plugins: {
          legend: {
              display: false
          }
      }
    };

    return (
      <Container>
        <div style={{ position: 'relative', height: '300px', width: '100%' }}>
          <Bar data={data} options={options} />
        </div>
      </Container>
    );
  };
  